import React from 'react';
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  onClose: () => void;
  visible: boolean;
}

const toastIcons = {
  success: CheckCircle,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
};

const toastStyles = {
  success: 'text-green-400',
  error: 'text-red-400',
  warning: 'text-yellow-400',
  info: 'text-blue-400',
};

export function Toast({ message, type = 'info', title, onClose, visible }: ToastProps) {
  if (!visible) return null;

  const Icon = toastIcons[type];
  const styleClass = toastStyles[type];

  return (
    <div className="toast-container">
      <div className={`toast ${type}`}>
        <Icon className={`toast-icon ${styleClass}`} size={20} />
        <div className="toast-content">
          {title && <p className="toast-title">{title}</p>}
          <p className="toast-message">{message}</p>
        </div>
        <button className="toast-close" onClick={onClose}>
          <X size={16} />
        </button>
      </div>
    </div>
  );
}

